import _ from "lodash";

export const entity = {
    name: "Axis",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        "AxisType",
        {
            path: "fullName",
            fieldPath: ['axisType.translatedName', 'translatedName'],
            $f: function (object, context, callback) {
                const translate = context?.tc || (w => w)
                return callback(null, `${object.axisType?.translatedName}${translate('colon_separator')}${object.translatedName}`)
            }
        }
    ],
    filters: [
        {
            name: "byAxisType",
            path: "axisType",
            object: "AxisType",
            display: "name",
            translateName: true,
            clearable: true,
            client: true,
            isDefault: false,
            query: function (context) {
                const axisTypeId = _.get(context.data, "axisType.id")
                return axisTypeId ? {axisType: new global.ObjectID(axisTypeId)} : {}
            }
        },
        {
            name: "excludeSelectedTypes",
            isDefault: false,
            query: function(context) {
                const selectedAxesTypes = _.get(context, 'data.axesTypes') || []

                const selectedIds = selectedAxesTypes.map(sh => new global.ObjectID(sh.id))

                const usedTypeIds = selectedAxesTypes
                    .filter(sh => sh.axisType)
                    .map(sh => new global.ObjectID(sh.axisType.id))

                return usedTypeIds.length > 0 ?
                    {
                        $or: [
                            { axisType: { $nin: usedTypeIds } }, // exclude used types
                            { _id: { $in: selectedIds } }               // but keep selected ones
                        ]
                    }
                    : {}
            }
        }
    ]
}

export const module_ = {
    object: "Axis",
    tKey: "mTitle_axis",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            {path: "axisType", display: "codeName"},
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "axisType", display: "codeName"},
            {path: "code"},
            {path: "name", type: "textarea"}
        ]
    },
    filters: ["byAxisType"]
}
